import { render, staticRenderFns } from "./ShareableLinkComponent.vue?vue&type=template&id=36f59cd7&"
import script from "./ShareableLinkComponent.vue?vue&type=script&lang=js&"
export * from "./ShareableLinkComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShareableLinkComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports